export const ADMIN = 'ADMIN';
export const USER = 'USER';
export const BUCKET_PATH = `https://${process.env.REACT_APP_ASSESTS_BUCKET}.s3.amazonaws.com/assets/icons/`;
export const LDAP_GROUPS = 'ldapGroups';
export const LDAP_USERNAME = 'ldapUsername';
export const LDAP_PASSWORD = 'ldapPassword';
export const LDAP_IS_MUST_SELECT_GROUP = 'ldapIsMustSelectGroup';